import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Card, CardContent, Typography, Grid, Box } from "@material-ui/core";
import { MutantApiService } from "../../../../services/MutantApiService";
import Loading from "../../../home/components/Loading";
import Swal from "sweetalert2";

export default function TaskInfoPage() {
	const { uuid } = useParams();
	const [taskInfo, setTaskInfo] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchTaskInfo = async () => {
			try {
				const api = new MutantApiService();
				const response = await api.makeHttpRequest({
					method: "GET",
					url: `/tasks/info?uuid=${uuid}`
				});
				setTaskInfo(response);
				setLoading(false);
			} catch (error) {
				console.error("Erro ao buscar informações da tarefa:", error);
				if (loading) {
					await Swal.fire("Erro!", "Erro ao buscar informações da tarefa.", "error");
				}
				setLoading(false);
			}
		};

		if (uuid) {
			fetchTaskInfo();
			
			// Atualizar a cada 5 segundos
			const interval = setInterval(() => {
				fetchTaskInfo();
			}, 5000);

			// Limpar o intervalo quando o componente for desmontado
			return () => clearInterval(interval);
		} else {
			setLoading(false);
		}
	}, [uuid]);

	if (loading) {
		return <Loading isLoading={true} />;
	}

	if (!taskInfo) {
		return (
			<Container maxWidth="md" style={{ marginTop: "2rem" }}>
				<Card>
					<CardContent>
						<Typography variant="h6" color="error">
							Não foi possível carregar as informações da tarefa.
						</Typography>
					</CardContent>
				</Card>
			</Container>
		);
	}

	return (
		<Container maxWidth="md" style={{ marginTop: "2rem" }}>
			<Card>
				<CardContent>
					<Typography variant="h4" gutterBottom>
						Status de tarefa de sintetização de audios.
					</Typography>

					<Box mb={3}>
						<Typography variant="h6" color="primary">
							UUID: {taskInfo.uuid}
						</Typography>
					</Box>

					<Grid container spacing={3}>
						<Grid item xs={12} sm={6} md={4}>
							<Card variant="outlined">
								<CardContent>
									<Typography variant="h6" color="primary">
										Total de Itens
									</Typography>
									<Typography variant="h4">
										{taskInfo.totalItems}
									</Typography>
								</CardContent>
							</Card>
						</Grid>

						<Grid item xs={12} sm={6} md={4}>
							<Card variant="outlined">
								<CardContent>
									<Typography variant="h6" color="primary">
										Pendente
									</Typography>
									<Typography variant="h4">
										{taskInfo.pendingCount}
									</Typography>
								</CardContent>
							</Card>
						</Grid>

						<Grid item xs={12} sm={6} md={4}>
							<Card variant="outlined">
								<CardContent>
									<Typography variant="h6" color="primary">
										Na Fila
									</Typography>
									<Typography variant="h4">
										{taskInfo.queueCount}
									</Typography>
								</CardContent>
							</Card>
						</Grid>

						<Grid item xs={12} sm={6} md={4}>
							<Card variant="outlined">
								<CardContent>
									<Typography variant="h6" color="primary">
										Processado
									</Typography>
									<Typography variant="h4" style={{ color: "#1F7A1F" }}>
										{taskInfo.processedCount}
									</Typography>
								</CardContent>
							</Card>
						</Grid>

						<Grid item xs={12} sm={6} md={4}>
							<Card variant="outlined">
								<CardContent>
									<Typography variant="h6" color="primary">
										Meta
									</Typography>
									<Typography variant="h4">
										{taskInfo.metaCount}
									</Typography>
								</CardContent>
							</Card>
						</Grid>

						<Grid item xs={12} sm={6} md={4}>
							<Card variant="outlined">
								<CardContent>
									<Typography variant="h6" color="primary">
										Origem
									</Typography>
									<Typography variant="h4">
										{taskInfo.origin}
									</Typography>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
		</Container>
	);
}